<template>
  <div class="address-component" @closeDialog="close" @saveDialog="save">
    <el-dialog :title="item.id ? '编辑地址':'创建地址'" :visible.sync="showDialog" :before-close="close"
               :show-close="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="收货人" prop="consignee">
          <el-input placeholder="请输入收货人" v-model="form.consignee"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input placeholder="请输入手机号码" v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="cascader">
          <el-cascader ref="cascaderArr" placeholder="请选择所在地区" v-model="cascader" :props="props"
                       @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input placeholder="请输入详细地址" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-checkbox v-model="form.isDefault">设为默认收货地址</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getAmap} from '@/api/address'

let id = 0;
export default {
  name: "addAddressComponent",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    'item': {
      handler(newVal, oldVal) {
        if (!newVal.id) {
          newVal.isDefault = false
        }

        this.form = {...newVal}

        if (newVal.code) {
          let province = newVal.code.slice(0, 2) + '0000';
          let city = newVal.code.slice(0, 4) + '00';
          let district = newVal.code.slice(0, 6);
          this.cascader = [province, city, district]
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    let validateCascader = (rule, value, callback) => {
      if (this.cascader.length === 0) {
        return callback(new Error('请选择所属地区'));
      } else {
        callback();
      }
    };
    return {
      showDialog: true,
      form: {
        isDefault: false
      },
      checked: false,
      cascader: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const {value, level} = node
          getAmap(value === undefined ? '' : value).then(response => {
            resolve(response.districts[0].districts.map(item => {
              return {
                value: item.adcode,
                label: item.name,
                leaf: level >= 2
              }
            }));
          })
        }
      },
      rules: {
        consignee: [
          {required: true, message: '请输入收货人', trigger: 'change'}
        ],
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入详细地址', trigger: 'change'}
        ],
        cascader: [
          {required: true, validator: validateCascader, trigger: 'blur'}
        ],
      }
    };
  },
  methods: {
    close() {
      this.$emit("closeDialog", false)
    },
    save() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$emit("saveDialog", this.form)
        } else {
          return false;
        }
      });
    },
    handleChange(e) {

      let checkedNode = this.$refs["cascaderArr"].getCheckedNodes();

      this.form.code = checkedNode[0].path[checkedNode[0].path.length - 1]

      this.form.province = checkedNode[0].pathLabels[0];
      this.form.city = checkedNode[0].pathLabels[1];
      this.form.district = checkedNode[0].pathLabels[2];
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.address-component {
  .el-dialog {
    width: 690px;
    border-radius: 10px;

    .el-dialog__header {
      padding: 40px 24px 0;

      .el-dialog__title {
        font-size: 24px;
        font-weight: 400;
        color: #262728;
      }
    }

    .el-dialog__body {
      padding: 40px;

      .el-checkbox__label {
        color: #909399;
      }

      .el-form-item__label {
        text-align: left;
      }

      .el-input__inner {
        border: 1px solid #EDEFF2;
        border-radius: 10px;
      }

      .el-cascader {
        width: 100%;
      }
    }
  }
}

</style>